import React from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import BankRoll from "components/Game/BankRoll";
import Queue from "components/Game/Queue";
import TopBarGames from "components/Game/Addons/TopBar";
import Game from "./Game";
import Bet from "./Bet";
import Engine from "./Engine";
import { isMobile, wait, Event } from 'utils/Helper';
import Loading from "games/Loading";
import HighLowPopup from "./Graph";

class Index extends React.Component {
  _Mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: new Engine(),
      margin: "mt-3",
      padding: "p-1",
      showPopup: false,
    };
    this.handleShowPopUp = this.handleShowPopUp.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }
  handleShowPopUp() {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
    }));
  }

  componentDidMount() {
    this._Mounted = true;
    let { engine } = this.state;

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // Start Engine
    engine.started = true;

    wait(600).then(() => {
      this.handleResize();
    });
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    let { engine } = this.state;
    window.removeEventListener("resize", this.handleResize);

    wait(300).then(() => {
      this._Mounted = false;
    });

    // Stop Engine
    engine.started = false;
    engine.trigger = null;
    engine.off();
  }

  handleResize() {
    let clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;

    if (clientWidth < 1540) {
      this.setState({ col: "col-xl-12" });
      Event.emit("hide_games");
    } else {
      this.setState({ col: "col-md-12" });
      Event.emit("show_min_games");
    }

    if (isMobile()) {
      this.setState({ padding: "p-0", margin: "mt-1", ovh: "ovh" });
    }
  }
  render() {
    let { col, padding, ovh } = this.state;

    const help = (
      <p className={"font-light text-white font-15"}>
        At the High or Low game, the result should be higher or lower than 500.
        and if you choose equal, the result must be equal to one of the round
        numbers. 111, 222, etc...
      </p>
    );

    return (
      <>
        <Helmet>
          <title>High or Low</title>
          
          <link rel="canonical" href="/high-or-low" />
        </Helmet>
        <div>
          {this._Mounted ? (
            <div
              className={`${col} ${padding}`}
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              {this.state.showPopup && (
                <HighLowPopup
                  onClose={this.handleShowPopUp}
                  engine={this.state.engine}
                />
              )}

              <Row className={"animated fadeIn " + ovh}>
                <div className="d-none">
                  Crypto High or Low Game Description: {help}
                </div>
                <Col sm={12} className={"m-auto " + col + " " + padding}>
                 
                <Row className='limbo-bet-and-game-section'>
                    {/* BET */}
                    <Card style={{padding:"0px",borderRight:"1px solid #31343C",borderTopLeftRadius:"20px",borderBottomLeftRadius:"20px"}} className="mb-0 col-md-4 limbo-bet-and-game-section-bet">
                      <Card.Body className={padding}>
                        <Row>
                          <Col style={{padding:"0px"}} sm={12} md={12} className={'m-auto'}>
                            <Bet engine={this.state.engine} />
                          </Col>
                        </Row>
                      </Card.Body>
                       {/* BANKROLL */}
 <Card style={{borderBottomRightRadius:"20px"}} className="mb-0 top-menus-limbo-bet">
                    <Card.Body style={{borderTop:"1px solid #31343C"}}  className="px-2 py-3">
                      <Row>
                        {/* <Col md={6} className={"col-6 text-left"}>
                          <BankRoll game={"high_low"} />
                        </Col> */}
                      <Col md={12} style={{padding:"0px"}} className={' text-right'}>
                        <div style={{ display: "flex" }}>
                          <Col style={{padding:"0px"}} className={' text-right'}>
                            <TopBarGames
                              help={help}
                              image="/assets/images/covers_new/____hilo.png"
                            />
                          </Col>
                          {/* <div
                            onClick={this.handleShowPopUp}
                            style={{
                              marginLeft: "26px",
                              alignItems: "center",
                              height: "37px",
                              width: "37px",
                              borderRadius: "5px",
                              backgroundColor: "#1B2336",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              style={{ height: "17px", width: "17px" }}
                              src="/assets/images/nanoicons/nanoswap.png"
                              alt="Swap"
                            />
                          </div> */}
                        </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                    </Card>

                    {/* GAME */}
                    <Card style={{padding:"0px",borderTopRightRadius:"20px",background:"#16171A",borderBottomRightRadius:"20px"}} className="mb-0 col-md-8 limbo-bet-and-game-section-game">
                      <Card.Body
                        className={"bg-dice-options hash_diceBG p-1"}
                        id="roll-panel"
                      >
                        <Row>
                          <Col style={{padding:"0px"}} sm={12} md={12} className={'m-auto'}>
                            <Game engine={this.state.engine} />
                          </Col>
                        </Row>
                      </Card.Body>
                       {/* BANKROLL */}
 <Card style={{borderBottomRightRadius:"20px"}} className="mb-0 top-menus-limbo-game">
                    <Card.Body style={{borderTop:"1px solid #31343C"}}  className="px-2 py-3">
                      <Row>
                        {/* <Col md={6} className={"col-6 text-left"}>
                          <BankRoll game={"high_low"} />
                        </Col> */}
                      <Col md={12} style={{padding:"0px"}} className={' text-right'}>
                        <div style={{ display: "flex" }}>
                          <Col style={{padding:"0px"}} className={' text-right'}>
                            <TopBarGames
                              help={help}
                              image="/assets/images/covers_new/____hilo.png"
                            />
                          </Col>
                          {/* <div
                            onClick={this.handleShowPopUp}
                            style={{
                              marginLeft: "26px",
                              alignItems: "center",
                              height: "37px",
                              width: "37px",
                              borderRadius: "5px",
                              backgroundColor: "#1B2336",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              style={{ height: "17px", width: "17px" }}
                              src="/assets/images/nanoicons/nanoswap.png"
                              alt="Swap"
                            />
                          </div> */}
                        </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                    </Card>
                  </Row>

                  {/* QUEUE */}
                  <Card style={{borderRadius:'20px'}} className="mb-5 mt-2">
                    <Card.Body className="p-1">
                      <Row>
                        <Col sm={12} md={12} className={"m-auto px-1"}>
                          <Queue t={this.props.t} game={"high_low"} />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}

export default Index;
